





















































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Test, Project } from '@shared/types/database'
import { TextInput, Button, Pill, Icon } from '@alpha/ink'
import * as graph from '@shared/types/graphql'
import Breadcrumbs, { Crumb } from '@/components/Breadcrumbs.vue'
import store from '@/store'
import PageHeader from '@/components/PageHeader.vue'
import TestInfo from '@/components/TestDetails/TestInfo.vue'

import { PresetTestMessages } from '@/store/modules/notification-store-module'
import TestDetailsHeaderActions from './TestDetailsHeaderActions.vue'

@Component({
  components: {
    Button,
    Breadcrumbs,
    TestDetailsHeaderActions,
    PageHeader,
    Pill,
    Icon,
    TextInput,
    TestInfo
  }
})
export default class TestDetailsHeader extends Vue {
  @Prop({ required: true }) test!: Test
  @Prop({ required: true }) audience!: Partial<graph.Audience>
  @Prop({ required: true }) livechartsEnabled!: boolean
  @Prop({ required: false }) project?: Project
  @Prop({ default: false }) canEditTitle?: boolean
  @Prop({ default: false }) templateInputsValidated!:boolean
  @Prop({ default: false }) readonly isAdmin?: boolean
  @Prop({ default: true }) isTemplated?: boolean
  @Prop({ required: true }) canClone!: boolean

  saving:boolean = false
  saveDone:boolean = false
  editMode: boolean = false
  newTitle: string = this.title

  get crumbs (): Crumb[] {
    const workspace = store.state.workspace.workspace
    const result: Crumb[] = []

    result.push({ title: workspace.name, url: `/workspaces/${workspace.id}/projects` })

    if (this.project) {
      result.push({ title: this.project.title, url: `/workspaces/${workspace.id}/projects/${this.project.id}` })
    }

    result.push({ title: 'Test' })

    return result
  }

  get title () {
    return this.test.payload.title ?? ''
  }

  get status () {
    return this.test.payload.status
  }

  get audienceName (): string {
    return this.audience?.name ?? ''
  }

  validateTemplate () {
    this.$emit('validateTemplate')
  }

  saveTitle () {
    this.editMode = false
    if (this.newTitle.trim() && this.newTitle.trim() !== this.title.trim()) {
      this.saveTitleChange(this.newTitle)
    } else {
      this.newTitle = this.title
    }
  }

  closeInputEdit (event:FocusEvent) {
    if (event.relatedTarget) {
      this.saveTitle()
    } else {
      this.newTitle = this.title
      this.editMode = false
    }
  }

  allowInputUpdate (event:FocusEvent) {
    if (!event.relatedTarget) {
      this.editMode = false
    }
  }

  editTitle () {
    this.editMode = true
  }

  async saveTitleChange (newTitle:string) {
    this.saving = true
    this.saveDone = false
    const testId = this.test.id.toString()
    const test = {
      title: newTitle
    }
    const result = await store.dispatch.workspace.updateTest({ test: test, workspaceId: store.state.workspace.workspace.id, testId: testId })
    if (!result) {
      store.dispatch.notification.setMessage(PresetTestMessages.updateFail)
    } else {
      store.dispatch.notification.setMessage(PresetTestMessages.updateSuccess)
    }
    this.saving = false
    this.saveDone = true
  }
}
